// Hak akses 3 tingkat: tidak bisa akses · lihat saja · bisa ubah.
//
// Kunci berbentuk jalur bertitik, dari kasar ke rinci:
//   'pengaturan'                    → menu
//   'pengaturan.supplier'           → sub-menu di dalamnya
//   'pengaturan.supplier.hapus'     → aksi
//
// ATURAN INDUK (yang membuat ini enak dipakai): anak TIDAK PERNAH melebihi induknya.
// Setel menu Supplier ke "lihat saja" → seluruh tambah/ubah/hapus di dalamnya ikut jadi
// lihat-saja tanpa perlu disetel satu per satu. Menaikkan anak di atas induk tidak berlaku —
// kalau tidak, satu baris yang terlewat bisa membuka kembali menu yang sengaja dikunci.
export type Level = 'none' | 'read' | 'full';

const RANK: Record<Level, number> = { none: 0, read: 1, full: 2 };
const kecil = (a: Level, b: Level): Level => (RANK[a] <= RANK[b] ? a : b);

/** Peta sparse: hanya kunci yang BEDA dari bawaan yang disimpan. */
export type PetaAkses = Record<string, Level>;

/**
 * Level efektif satu kunci. `cari` diperiksa untuk tiap tingkat jalur (menu → sub → aksi);
 * tingkat yang tak diatur mewarisi induknya, tingkat yang diatur dijepit ke induknya.
 */
export function levelOf(key: string, cari: (k: string) => Level | undefined, akar: Level = 'full'): Level {
  const seg = key.split('.');
  let lvl = akar;
  for (let i = 0; i < seg.length; i++) {
    const own = cari(seg.slice(0, i + 1).join('.'));
    if (own !== undefined) lvl = kecil(lvl, own);
  }
  return lvl;
}

/** Pencari berlapis: override karyawan menang atas setelan grup, grup menang atas bawaan. */
export const cariBerlapis = (...peta: (PetaAkses | undefined)[]) => (k: string): Level | undefined => {
  for (const p of peta) { const v = p?.[k]; if (v !== undefined) return v; }
  return undefined;
};

export const bisaLihat = (l: Level): boolean => l !== 'none';
export const bisaUbah = (l: Level): boolean => l === 'full';

/** Buang entri yang sama dengan bawaannya — supaya perbaikan bawaan berikutnya tetap sampai. */
export function ringkas(peta: PetaAkses, bawaan: (k: string) => Level | undefined): PetaAkses {
  const out: PetaAkses = {};
  for (const [k, v] of Object.entries(peta)) if (bawaan(k) !== v) out[k] = v;
  return out;
}

export const LEVEL_LABEL: Record<Level, string> = {
  none: '⛔ Tidak bisa akses',
  read: '👁️ Lihat saja',
  full: '✏️ Bisa ubah',
};
